/**
 * @generated SignedSource<<462382aad9dcf4f19d4e743be8f90e07>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "code"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "code",
    "variableName": "code"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "databaseId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasMatchplays",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "markerCode",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startingHole",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "verifiedCode",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mustResolveTies",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasChallenges",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "shotgun",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasPairs",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "position",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "strokes",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "flightId",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startDate",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "finishedHoles",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "flightStatus",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "previousPosition",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "previousCategoryPosition",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "score",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "aggregatePosition",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "aggregateCategoryPosition",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "aggregateScore",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "aggregateStrokes",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "calculatedScores",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "concreteType": "Organisation",
  "kind": "LinkedField",
  "name": "organisation",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "color",
      "storageKey": null
    },
    (v4/*: any*/)
  ],
  "storageKey": null
},
v30 = [
  (v7/*: any*/),
  (v4/*: any*/)
],
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "category",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "categoryPosition",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isFavorite",
  "storageKey": null
},
v36 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isRankedEntry"
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nationality",
  "storageKey": null
},
v38 = [
  (v33/*: any*/),
  (v34/*: any*/),
  (v4/*: any*/)
],
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "scoreTemplate",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "holesWonTeamA",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "holesWonTeamB",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "teamA",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "teamB",
  "storageKey": null
},
v44 = [
  (v14/*: any*/),
  (v4/*: any*/)
],
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasScores",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "round",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "matchplayType",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "winnerAfterPenaltyPutts",
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hole",
  "storageKey": null
},
v50 = [
  (v37/*: any*/),
  (v4/*: any*/),
  (v33/*: any*/),
  (v34/*: any*/)
],
v51 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "matchplayPlayerId",
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "invalidHoles",
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "incompleteHoles",
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "scoresForInput",
  "storageKey": null
},
v55 = {
  "alias": null,
  "args": null,
  "concreteType": "Pair",
  "kind": "LinkedField",
  "name": "pair",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Player",
      "kind": "LinkedField",
      "name": "playerA",
      "plural": false,
      "selections": (v44/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Player",
      "kind": "LinkedField",
      "name": "playerB",
      "plural": false,
      "selections": (v44/*: any*/),
      "storageKey": null
    },
    (v4/*: any*/)
  ],
  "storageKey": null
},
v56 = {
  "alias": null,
  "args": null,
  "concreteType": "Player",
  "kind": "LinkedField",
  "name": "player",
  "plural": false,
  "selections": (v44/*: any*/),
  "storageKey": null
},
v57 = {
  "alias": null,
  "args": null,
  "concreteType": "Flight",
  "kind": "LinkedField",
  "name": "flight",
  "plural": false,
  "selections": [
    (v8/*: any*/),
    (v4/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MyFlightQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Flight",
        "kind": "LinkedField",
        "name": "flight",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Tournament",
            "kind": "LinkedField",
            "name": "tournament",
            "plural": false,
            "selections": [
              (v9/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TournamentRound",
            "kind": "LinkedField",
            "name": "tournamentRound",
            "plural": false,
            "selections": [
              (v10/*: any*/),
              (v11/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Tournament",
                "kind": "LinkedField",
                "name": "tournament",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "MatchplayModal_tournament"
                  }
                ],
                "storageKey": null
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "HoleAlert_tournamentRound"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "HoleInfo_tournamentRound"
              }
            ],
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "HolePlayers_flight"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "MyFlight_flight"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "RankingModal_flight"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MyFlightQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Flight",
        "kind": "LinkedField",
        "name": "flight",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Tournament",
            "kind": "LinkedField",
            "name": "tournament",
            "plural": false,
            "selections": [
              (v9/*: any*/),
              (v4/*: any*/),
              (v12/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "tournamentRoundsCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "rankedEntries",
                "plural": true,
                "selections": [
                  (v13/*: any*/),
                  (v4/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FlightScore",
                        "kind": "LinkedField",
                        "name": "activeFlightScore",
                        "plural": false,
                        "selections": [
                          (v17/*: any*/),
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Flight",
                            "kind": "LinkedField",
                            "name": "flight",
                            "plural": false,
                            "selections": [
                              (v18/*: any*/),
                              (v4/*: any*/),
                              (v6/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v13/*: any*/),
                          (v19/*: any*/),
                          (v20/*: any*/),
                          (v21/*: any*/),
                          (v22/*: any*/),
                          (v23/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FlightScore",
                        "kind": "LinkedField",
                        "name": "flightScores",
                        "plural": true,
                        "selections": [
                          (v24/*: any*/),
                          (v4/*: any*/),
                          (v13/*: any*/),
                          (v25/*: any*/),
                          (v26/*: any*/),
                          (v27/*: any*/),
                          (v28/*: any*/),
                          (v19/*: any*/),
                          (v23/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Flight",
                            "kind": "LinkedField",
                            "name": "flight",
                            "plural": false,
                            "selections": [
                              (v18/*: any*/),
                              (v6/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TournamentRound",
                                "kind": "LinkedField",
                                "name": "tournamentRound",
                                "plural": false,
                                "selections": [
                                  (v11/*: any*/),
                                  (v7/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Tournament",
                                    "kind": "LinkedField",
                                    "name": "tournament",
                                    "plural": false,
                                    "selections": [
                                      (v29/*: any*/),
                                      (v4/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v4/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v4/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Pair",
                            "kind": "LinkedField",
                            "name": "pair",
                            "plural": false,
                            "selections": (v30/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TournamentPlayer",
                            "kind": "LinkedField",
                            "name": "tournamentPlayer",
                            "plural": false,
                            "selections": (v30/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "FlightScoresInterface",
                    "abstractKey": "__isFlightScoresInterface"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v31/*: any*/),
                      (v32/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Player",
                        "kind": "LinkedField",
                        "name": "player",
                        "plural": false,
                        "selections": [
                          (v33/*: any*/),
                          (v34/*: any*/),
                          (v4/*: any*/),
                          (v35/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "TournamentPlayer",
                    "abstractKey": null
                  },
                  (v36/*: any*/),
                  (v37/*: any*/),
                  (v23/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Player",
                        "kind": "LinkedField",
                        "name": "playerA",
                        "plural": false,
                        "selections": (v38/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Player",
                        "kind": "LinkedField",
                        "name": "playerB",
                        "plural": false,
                        "selections": (v38/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "type": "Pair",
                    "abstractKey": null
                  },
                  (v2/*: any*/),
                  (v7/*: any*/)
                ],
                "storageKey": null
              },
              (v2/*: any*/),
              (v29/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "activeRound",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "useBestRound",
                "storageKey": null
              },
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "TournamentRound",
                "kind": "LinkedField",
                "name": "activeTournamentRound",
                "plural": false,
                "selections": [
                  (v11/*: any*/),
                  (v4/*: any*/),
                  (v39/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPairsPlus",
                "storageKey": null
              },
              {
                "alias": "pairs",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "pairs",
                    "value": true
                  }
                ],
                "concreteType": null,
                "kind": "LinkedField",
                "name": "rankedEntries",
                "plural": true,
                "selections": [
                  (v13/*: any*/),
                  (v4/*: any*/),
                  (v15/*: any*/),
                  (v36/*: any*/),
                  (v2/*: any*/),
                  (v23/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v7/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FlightScore",
                        "kind": "LinkedField",
                        "name": "activeFlightScores",
                        "plural": true,
                        "selections": [
                          (v19/*: any*/),
                          (v20/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "playerId",
                            "storageKey": null
                          },
                          (v23/*: any*/),
                          (v16/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Flight",
                            "kind": "LinkedField",
                            "name": "flight",
                            "plural": false,
                            "selections": [
                              (v18/*: any*/),
                              (v6/*: any*/),
                              (v4/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "scores",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Player",
                        "kind": "LinkedField",
                        "name": "playerA",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v14/*: any*/),
                          (v37/*: any*/),
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Player",
                        "kind": "LinkedField",
                        "name": "playerB",
                        "plural": false,
                        "selections": [
                          (v14/*: any*/),
                          (v37/*: any*/),
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "Pair",
                    "abstractKey": null
                  }
                ],
                "storageKey": "rankedEntries(pairs:true)"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "TournamentRound",
                "kind": "LinkedField",
                "name": "tournamentRounds",
                "plural": true,
                "selections": [
                  (v39/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TournamentRound",
            "kind": "LinkedField",
            "name": "tournamentRound",
            "plural": false,
            "selections": [
              (v10/*: any*/),
              (v11/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Tournament",
                "kind": "LinkedField",
                "name": "tournament",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v12/*: any*/),
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TeamplayConfiguration",
                    "kind": "LinkedField",
                    "name": "teamplayConfiguration",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "colorA",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "colorB",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TeamplayScore",
                        "kind": "LinkedField",
                        "name": "overallTeamplayScore",
                        "plural": false,
                        "selections": [
                          (v13/*: any*/),
                          (v4/*: any*/),
                          (v40/*: any*/),
                          (v41/*: any*/),
                          (v42/*: any*/),
                          (v43/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TeamplayTeam",
                        "kind": "LinkedField",
                        "name": "teamA",
                        "plural": false,
                        "selections": (v44/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TeamplayTeam",
                        "kind": "LinkedField",
                        "name": "teamB",
                        "plural": false,
                        "selections": (v44/*: any*/),
                        "storageKey": null
                      },
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TournamentRound",
                    "kind": "LinkedField",
                    "name": "tournamentRounds",
                    "plural": true,
                    "selections": [
                      (v45/*: any*/),
                      (v46/*: any*/),
                      (v7/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Matchplay",
                        "kind": "LinkedField",
                        "name": "matchplays",
                        "plural": true,
                        "selections": [
                          (v2/*: any*/),
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "teamplay",
                            "storageKey": null
                          },
                          (v47/*: any*/),
                          (v14/*: any*/),
                          (v23/*: any*/),
                          (v18/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MatchplayPlayer",
                            "kind": "LinkedField",
                            "name": "matchplayPlayers",
                            "plural": true,
                            "selections": [
                              (v15/*: any*/),
                              (v48/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Player",
                                "kind": "LinkedField",
                                "name": "player",
                                "plural": false,
                                "selections": (v38/*: any*/),
                                "storageKey": null
                              },
                              (v4/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MatchplayHole",
                            "kind": "LinkedField",
                            "name": "matchplayHoles",
                            "plural": true,
                            "selections": [
                              (v49/*: any*/),
                              (v23/*: any*/),
                              (v4/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "strokesA",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "strokesB",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "strokesC",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "strokesD",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TeamplayScore",
                        "kind": "LinkedField",
                        "name": "teamplayScore",
                        "plural": false,
                        "selections": [
                          (v40/*: any*/),
                          (v41/*: any*/),
                          (v4/*: any*/),
                          (v42/*: any*/),
                          (v43/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Tournament",
                        "kind": "LinkedField",
                        "name": "tournament",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TournamentRound",
                            "kind": "LinkedField",
                            "name": "tournamentRounds",
                            "plural": true,
                            "selections": [
                              (v45/*: any*/),
                              (v4/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "holeInOneHole",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "longestDriveHole",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "nearyHole",
                "storageKey": null
              },
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "FlightScore",
                "kind": "LinkedField",
                "name": "rankedFlightScores",
                "plural": true,
                "selections": [
                  (v25/*: any*/),
                  (v24/*: any*/),
                  (v32/*: any*/),
                  (v17/*: any*/),
                  (v4/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Flight",
                    "kind": "LinkedField",
                    "name": "flight",
                    "plural": false,
                    "selections": [
                      (v18/*: any*/),
                      (v4/*: any*/),
                      (v6/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TournamentRound",
                        "kind": "LinkedField",
                        "name": "tournamentRound",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Tournament",
                            "kind": "LinkedField",
                            "name": "tournament",
                            "plural": false,
                            "selections": [
                              (v12/*: any*/),
                              (v29/*: any*/),
                              (v4/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v4/*: any*/),
                          (v11/*: any*/),
                          (v7/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Player",
                    "kind": "LinkedField",
                    "name": "player",
                    "plural": false,
                    "selections": [
                      (v35/*: any*/),
                      (v4/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v26/*: any*/),
                  (v27/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "aggregateFinishedHoles",
                    "storageKey": null
                  },
                  (v19/*: any*/),
                  (v20/*: any*/),
                  (v22/*: any*/),
                  (v21/*: any*/),
                  (v23/*: any*/),
                  (v16/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Pair",
                    "kind": "LinkedField",
                    "name": "pair",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v7/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Player",
                        "kind": "LinkedField",
                        "name": "playerA",
                        "plural": false,
                        "selections": (v50/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Player",
                        "kind": "LinkedField",
                        "name": "playerB",
                        "plural": false,
                        "selections": (v50/*: any*/),
                        "storageKey": null
                      },
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TournamentPlayer",
                    "kind": "LinkedField",
                    "name": "tournamentPlayer",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Player",
                        "kind": "LinkedField",
                        "name": "player",
                        "plural": false,
                        "selections": [
                          (v37/*: any*/),
                          (v4/*: any*/),
                          (v31/*: any*/),
                          (v2/*: any*/),
                          (v33/*: any*/),
                          (v34/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v4/*: any*/),
                      (v31/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "tournamentId",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v13/*: any*/),
                  (v28/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              (v46/*: any*/),
              (v39/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "FlightScore",
            "kind": "LinkedField",
            "name": "activeFlightScores",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v51/*: any*/),
              (v52/*: any*/),
              (v53/*: any*/),
              (v4/*: any*/),
              (v54/*: any*/),
              (v55/*: any*/),
              (v56/*: any*/),
              (v57/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "FlightScore",
            "kind": "LinkedField",
            "name": "inactiveFlightScores",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v51/*: any*/),
              (v7/*: any*/),
              (v55/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Player",
                "kind": "LinkedField",
                "name": "player",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v14/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Matchplay",
            "kind": "LinkedField",
            "name": "matchplays",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "MatchplayPlayer",
                "kind": "LinkedField",
                "name": "matchplayPlayers",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "flightScoreId",
                    "storageKey": null
                  },
                  (v4/*: any*/),
                  (v2/*: any*/),
                  (v15/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FlightScore",
                    "kind": "LinkedField",
                    "name": "flightScore",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v56/*: any*/),
                      (v52/*: any*/),
                      (v53/*: any*/),
                      (v4/*: any*/),
                      (v51/*: any*/),
                      (v54/*: any*/),
                      (v55/*: any*/),
                      (v57/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "matchResult",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "loserAfterPenaltyPutts",
                    "storageKey": null
                  },
                  (v48/*: any*/),
                  (v56/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "competitionMatchupPlayerId",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v47/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "markerPendingConfirm",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "pendingConfirm",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "FlightHole",
            "kind": "LinkedField",
            "name": "flightHoles",
            "plural": true,
            "selections": [
              (v49/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "par",
                "storageKey": null
              },
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "strokeIndex",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Tee",
                "kind": "LinkedField",
                "name": "tees",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "distance",
                    "storageKey": null
                  },
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "visual",
                "storageKey": null
              },
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "scoresValid",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "bdc072098c25c7e3fd7f68b08993fa33",
    "id": null,
    "metadata": {},
    "name": "MyFlightQuery",
    "operationKind": "query",
    "text": "query MyFlightQuery(\n  $code: String!\n) {\n  flight(code: $code) {\n    databaseId\n    hasMatchplays\n    id\n    markerCode\n    startingHole\n    status\n    verifiedCode\n    tournament {\n      mustResolveTies\n      id\n    }\n    tournamentRound {\n      hasChallenges\n      shotgun\n      tournament {\n        databaseId\n        ...MatchplayModal_tournament\n        id\n      }\n      ...HoleAlert_tournamentRound\n      ...HoleInfo_tournamentRound\n      id\n    }\n    ...HolePlayers_flight\n    ...MyFlight_flight\n    ...RankingModal_flight\n  }\n}\n\nfragment ActivePlayer_flightScore on FlightScore {\n  ...ActivePlayer_flightScoreStatus\n  id\n  matchplayPlayerId\n  scoresForInput\n  pair {\n    playerA {\n      name\n      id\n    }\n    playerB {\n      name\n      id\n    }\n    id\n  }\n  player {\n    name\n    id\n  }\n  flight {\n    verifiedCode\n    id\n  }\n}\n\nfragment ActivePlayer_flightScoreStatus on FlightScore {\n  invalidHoles\n  incompleteHoles\n  id\n}\n\nfragment FinishedHoles_tournament on Tournament {\n  status\n  activeTournamentRound {\n    shotgun\n    id\n  }\n}\n\nfragment HoleAlert_tournamentRound on TournamentRound {\n  holeInOneHole\n  longestDriveHole\n  nearyHole\n}\n\nfragment HoleByHoleRoundScore_flightScore on FlightScore {\n  finishedHoles\n  score\n  flight {\n    startDate\n    startingHole\n    tournamentRound {\n      shotgun\n      status\n      tournament {\n        organisation {\n          color\n          id\n        }\n        id\n      }\n      id\n    }\n    id\n  }\n  pair {\n    status\n    id\n  }\n  tournamentPlayer {\n    status\n    id\n  }\n}\n\nfragment HoleByHoleTableEntry_flightScore on FlightScore {\n  calculatedScores\n  databaseId\n  finishedHoles\n  position\n  score\n  flight {\n    tournamentRound {\n      tournament {\n        hasPairs\n        organisation {\n          color\n          id\n        }\n        id\n      }\n      id\n    }\n    id\n  }\n  pair {\n    playerA {\n      firstName\n      lastName\n      nationality\n      id\n    }\n    playerB {\n      firstName\n      lastName\n      nationality\n      id\n    }\n    id\n  }\n  tournamentPlayer {\n    category\n    tournamentId\n    player {\n      category\n      databaseId\n      firstName\n      lastName\n      nationality\n      id\n    }\n    id\n  }\n  ...HoleByHoleRoundScore_flightScore\n}\n\nfragment HoleByHoleTableOverallEntry_rankedEntry_3zCxOT on RankedEntry {\n  __isRankedEntry: __typename\n  __typename\n  id\n  nationality\n  position\n  score\n  strokes\n  ... on FlightScoresInterface {\n    __isFlightScoresInterface: __typename\n    flightScores {\n      __typename\n      aggregateCategoryPosition\n      aggregatePosition\n      aggregateScore\n      aggregateStrokes\n      calculatedScores\n      id\n      ...HoleByHoleRoundScore_flightScore\n    }\n  }\n  ... on Pair {\n    playerA {\n      firstName\n      lastName\n      id\n    }\n    playerB {\n      firstName\n      lastName\n      id\n    }\n  }\n  ... on TournamentPlayer {\n    category\n    categoryPosition\n    player {\n      firstName\n      lastName\n      id\n    }\n  }\n}\n\nfragment HoleByHoleTableOverallEntry_tournament on Tournament {\n  databaseId\n  hasPairs\n  tournamentRoundsCount\n  organisation {\n    color\n    id\n  }\n}\n\nfragment HoleByHoleTable_tournament on Tournament {\n  hasPairs\n  tournamentRoundsCount\n  rankedEntries {\n    __typename\n    id\n    name\n    position\n    strokes\n    ... on FlightScoresInterface {\n      __isFlightScoresInterface: __typename\n      activeFlightScore {\n        flightId\n        id\n      }\n      flightScores {\n        aggregatePosition\n        id\n      }\n    }\n    ... on TournamentPlayer {\n      category\n      categoryPosition\n    }\n    ...HoleByHoleTableOverallEntry_rankedEntry_3zCxOT\n  }\n  ...HoleByHoleTableOverallEntry_tournament\n}\n\nfragment HoleByHoleTable_tournamentRound on TournamentRound {\n  id\n  round\n  scoreTemplate\n  rankedFlightScores {\n    __typename\n    flightId\n    id\n    name\n    position\n    strokes\n    flight {\n      startDate\n      id\n    }\n    ...HoleByHoleTableEntry_flightScore\n  }\n}\n\nfragment HoleInfo_flightHole on FlightHole {\n  hole\n  par\n  strokeIndex\n  tees {\n    distance\n    id\n  }\n  visual\n}\n\nfragment HoleInfo_tournamentRound on TournamentRound {\n  hasChallenges\n  holeInOneHole\n  longestDriveHole\n  nearyHole\n}\n\nfragment HoleMatchplayTeam_matchplay on Matchplay {\n  matchplayType\n  matchplayPlayers {\n    databaseId\n    position\n    flightScore {\n      databaseId\n      player {\n        name\n        id\n      }\n      ...ActivePlayer_flightScore\n      id\n    }\n    id\n  }\n}\n\nfragment HolePlayers_flight on Flight {\n  activeFlightScores {\n    databaseId\n    matchplayPlayerId\n    ...ActivePlayer_flightScore\n    id\n  }\n  inactiveFlightScores {\n    id\n    matchplayPlayerId\n    status\n    pair {\n      playerA {\n        name\n        id\n      }\n      playerB {\n        name\n        id\n      }\n      id\n    }\n    player {\n      databaseId\n      name\n      id\n    }\n  }\n  matchplays {\n    databaseId\n    matchplayPlayers {\n      flightScoreId\n      id\n    }\n    ...HoleMatchplayTeam_matchplay\n    id\n  }\n}\n\nfragment LeaderboardTableEntry_flightScore on FlightScore {\n  aggregateCategoryPosition\n  aggregatePosition\n  aggregateScore\n  aggregateStrokes\n  aggregateFinishedHoles\n  categoryPosition\n  finishedHoles\n  flightStatus\n  id\n  name\n  position\n  previousCategoryPosition\n  previousPosition\n  score\n  strokes\n  flight {\n    id\n    startingHole\n  }\n  pair {\n    databaseId\n    status\n    playerA {\n      nationality\n      id\n    }\n    playerB {\n      nationality\n      id\n    }\n    id\n  }\n  player {\n    databaseId\n    id\n  }\n  tournamentPlayer {\n    status\n    player {\n      nationality\n      id\n    }\n    id\n  }\n}\n\nfragment LeaderboardTableEntry_tournament on Tournament {\n  activeRound\n  ...FinishedHoles_tournament\n  ...Position_tournament\n  ...ScoreTotal_tournament\n}\n\nfragment LeaderboardTableOverallEntry_rankedEntry on RankedEntry {\n  __isRankedEntry: __typename\n  __typename\n  databaseId\n  id\n  name\n  nationality\n  position\n  status\n  score\n  strokes\n  ... on FlightScoresInterface {\n    __isFlightScoresInterface: __typename\n    activeFlightScore {\n      __typename\n      id\n      finishedHoles\n      flightStatus\n      previousPosition\n      previousCategoryPosition\n      score\n      flight {\n        id\n        startingHole\n      }\n    }\n    flightScores {\n      finishedHoles\n      id\n    }\n  }\n  ... on TournamentPlayer {\n    categoryPosition\n  }\n}\n\nfragment LeaderboardTableOverallEntry_tournament on Tournament {\n  activeRound\n  useBestRound\n  ...FinishedHoles_tournament\n  ...Position_tournament\n  ...ScoreTotal_tournament\n}\n\nfragment LeaderboardTableOverall_tournament_1Qcc8a on Tournament {\n  activeRound\n  rankedEntries {\n    __typename\n    id\n    name\n    position\n    ... on FlightScoresInterface {\n      __isFlightScoresInterface: __typename\n      activeFlightScore {\n        flightId\n        flight {\n          startDate\n          id\n        }\n        id\n      }\n    }\n    ... on TournamentPlayer {\n      categoryPosition\n      player {\n        isFavorite\n        id\n      }\n    }\n    ...LeaderboardTableOverallEntry_rankedEntry\n  }\n  ...LeaderboardTableOverallEntry_tournament\n}\n\nfragment LeaderboardTable_tournament on Tournament {\n  activeRound\n  useBestRound\n  ...LeaderboardTableEntry_tournament\n  ...LeaderboardTableOverall_tournament_1Qcc8a\n}\n\nfragment LeaderboardTable_tournamentRound on TournamentRound {\n  rankedFlightScores {\n    aggregateCategoryPosition\n    aggregatePosition\n    categoryPosition\n    flightId\n    id\n    name\n    position\n    flight {\n      startDate\n      id\n    }\n    player {\n      isFavorite\n      id\n    }\n    ...LeaderboardTableEntry_flightScore\n  }\n}\n\nfragment MatchplayLeaderboardTableEntryHoles_matchplay on Matchplay {\n  matchplayType\n  matchplayHoles {\n    id\n    score\n    strokesA\n    strokesB\n    strokesC\n    strokesD\n  }\n}\n\nfragment MatchplayLeaderboardTableEntry_matchplay on Matchplay {\n  id\n  matchplayType\n  name\n  score\n  startDate\n  matchplayPlayers {\n    position\n    winnerAfterPenaltyPutts\n    player {\n      firstName\n      lastName\n      id\n    }\n    id\n  }\n  matchplayHoles {\n    hole\n    score\n    id\n  }\n  ...MatchplayLeaderboardTableEntryHoles_matchplay\n}\n\nfragment MatchplayLeaderboardTable_tournament on Tournament {\n  hasPairs\n  id\n  teamplayConfiguration {\n    colorA\n    colorB\n    overallTeamplayScore {\n      __typename\n      id\n      holesWonTeamA\n      holesWonTeamB\n      teamA\n      teamB\n    }\n    teamA {\n      name\n      id\n    }\n    teamB {\n      name\n      id\n    }\n    id\n  }\n  tournamentRounds {\n    hasScores\n    round\n    status\n    matchplays {\n      databaseId\n      id\n      teamplay\n      ...MatchplayLeaderboardTableEntry_matchplay\n    }\n    teamplayScore {\n      holesWonTeamA\n      holesWonTeamB\n      id\n      teamA\n      teamB\n    }\n    tournament {\n      tournamentRounds {\n        hasScores\n        id\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment MatchplayModal_tournament on Tournament {\n  ...MatchplayLeaderboardTable_tournament\n  id\n}\n\nfragment MyFlight_flight on Flight {\n  markerPendingConfirm\n  pendingConfirm\n  status\n  flightHoles {\n    hole\n    par\n    status\n    ...HoleInfo_flightHole\n    id\n  }\n  matchplays {\n    id\n    matchplayPlayers {\n      databaseId\n      matchResult\n      loserAfterPenaltyPutts\n      winnerAfterPenaltyPutts\n      player {\n        name\n        id\n      }\n      id\n    }\n  }\n  id\n}\n\nfragment PairsPlusCollapse_pair on Pair {\n  activeFlightScores {\n    scores\n    id\n  }\n}\n\nfragment PairsPlusCollapse_tournament on Tournament {\n  activeTournamentRound {\n    scoreTemplate\n    id\n  }\n  organisation {\n    color\n    id\n  }\n  tournamentRounds {\n    scoreTemplate\n    id\n  }\n}\n\nfragment PairsPlusLeaderboardTableEntry_rankedEntry on RankedEntry {\n  __isRankedEntry: __typename\n  databaseId\n  position\n  score\n  ... on Pair {\n    status\n    activeFlightScores {\n      finishedHoles\n      flightStatus\n      playerId\n      score\n      strokes\n      flight {\n        startDate\n        startingHole\n        id\n      }\n      id\n    }\n    playerA {\n      databaseId\n      name\n      nationality\n      id\n    }\n    playerB {\n      name\n      nationality\n      id\n    }\n  }\n  ...PairsPlusCollapse_pair\n}\n\nfragment PairsPlusLeaderboardTableEntry_tournament on Tournament {\n  ...FinishedHoles_tournament\n  ...PairsPlusCollapse_tournament\n  ...Position_tournament\n  ...ScoreTotal_tournament\n}\n\nfragment PairsPlusLeaderboardTable_tournament on Tournament {\n  activeRound\n  databaseId\n  hasPairsPlus\n  status\n  pairs: rankedEntries(pairs: true) {\n    __typename\n    id\n    position\n    ...PairsPlusLeaderboardTableEntry_rankedEntry\n  }\n  ...PairsPlusLeaderboardTableEntry_tournament\n  id\n}\n\nfragment Position_tournament on Tournament {\n  activeRound\n}\n\nfragment RankingModalBody_flight on Flight {\n  databaseId\n  tournament {\n    ...HoleByHoleTable_tournament\n    ...LeaderboardTable_tournament\n    ...PairsPlusLeaderboardTable_tournament\n    id\n  }\n  tournamentRound {\n    ...LeaderboardTable_tournamentRound\n    ...HoleByHoleTable_tournamentRound\n    id\n  }\n}\n\nfragment RankingModalRefetch_flight on Flight {\n  markerPendingConfirm\n  pendingConfirm\n  scoresValid\n  status\n  matchplays {\n    id\n    matchplayPlayers {\n      competitionMatchupPlayerId\n      databaseId\n      matchResult\n      loserAfterPenaltyPutts\n      winnerAfterPenaltyPutts\n      player {\n        name\n        id\n      }\n      id\n    }\n  }\n  ...RankingModalBody_flight\n  id\n}\n\nfragment RankingModal_flight on Flight {\n  ...RankingModalRefetch_flight\n  markerCode\n  verifiedCode\n  tournament {\n    hasPairsPlus\n    mustResolveTies\n    id\n  }\n}\n\nfragment ScoreTotal_tournament on Tournament {\n  activeRound\n  organisation {\n    color\n    id\n  }\n}\n"
  }
};
})();

node.hash = "64915ad1137839efc22022d90fa212d2";

module.exports = node;
